export const Constants = {
    transactionType: {
        DIRECT_SALE: 'DIRECT_SALE',
        SIMPLE_QUOTATION: 'SIMPLE_QUOTATION',
        NORMAL: 'NORMAL',
        DIRECT_SALE_ADVANCE: 'DIRECT_SALE_ADVANCE'
    },
    listOfTransactionTypes: [
        {
            value: 'NORMAL',
            text: 'VENTA NORMAL'
        },
        {
            value: 'DIRECT_SALE',
            text: 'VENTA DIRECTA'
        },
        {
          value: "DIRECT_SALE_ADVANCE",
          text: "VENTA DIRECTA ANTICIPO",
        },
        {
            value: 'SIMPLE_QUOTATION',
            text: 'COTIZACIÓN SIMPLE'
        }
    ]
};
